import React from "react";
/* eslint-disable */
import {
    Box, TableBody, TableCell, TableContainer, TableHead, TableRow, Table, Stack,
    Card, Container
} from '@material-ui/core';

export default class ComponentToPrint extends React.Component {

    render() {
        const goodData = this.props.goodData;
        const goodDataDetails = this.props.goodDataDetails;
        const datetime = this.props.datetime;

        return (
            <Container>
                <Stack spacing={2}>
                    <Box display="flex" justifyContent="flex-end" p={2}>
                        <Card sx={{ border: '2px solid black', width: '800px', borderRadius: "0" }}>
                            <h5 style={{ marginLeft: '5px' }}>{datetime}</h5>
                            <h5><center>Cargills Retail (Private) Limited</center></h5>
                            <h5><center>{goodData.factoryName}</center></h5>
                            <h5><center>FDC Inbound Invoice</center></h5>
                            <div>&nbsp;</div>
                            <>
                                <Stack>
                                    <Box display="flex" justifyContent="flex-start" >
                                        <h5 style={{ marginLeft: '5px', width: '120px' }}>Date</h5>
                                        <h5 style={{ width: '220px' }}>{': ' + goodData.grnDate.split('T')[0]}</h5>
                                        <h5 style={{ marginLeft: '5px', width: '120px' }}>Inbound No </h5>
                                        <h5>{': ' + goodData.gtnNumber}</h5>
                                    </Box>
                                    <Box display="flex" justifyContent="flex-start" >
                                        <h5 style={{ marginLeft: '5px', width: '120px' }}>Transfer In To</h5>
                                        <h5 style={{ width: '220px' }}>{': ' + goodData.resFactoryName}</h5>
                                        <h5 style={{ marginLeft: '5px', width: '120px' }}>Inbound Amount</h5>
                                        <h5>{': ' + parseFloat(goodDataDetails.reduce((accumulator, current) => accumulator + (current.wacAmount * current.totalAmount), 0)).toLocaleString(undefined, { minimumFractionDigits: 2 })}</h5>
                                    </Box>
                                    <Box display="flex" justifyContent="flex-start" >
                                        <h5 style={{ marginLeft: '5px', width: '120px' }}>Vehicle Number</h5>
                                        <h5 style={{ width: '220px' }}>{': ' + goodDataDetails[0].vehicleNumber}</h5>
                                        <h5 style={{ marginLeft: '5px', width: '120px' }}>Create Count</h5>
                                        <h5>{': ' + goodDataDetails.reduce((accumulator, current) => accumulator + current.createCount, 0) ?? 0}</h5>
                                    </Box>
                                    <Box display="flex" justifyContent="flex-start" >
                                        <h5 style={{ marginLeft: '5px', width: '120px' }}>Vehicle Capacity</h5>
                                        <h5 style={{ width: '220px' }}>{': ' + parseFloat(goodDataDetails[0].capacity).toLocaleString(undefined, { minimumFractionDigits: 2 })}</h5>
                                        <h5 style={{ marginLeft: '5px', width: '120px' }}></h5>
                                        <h5>{ }</h5>
                                    </Box>
                                </Stack>
                                <TableContainer >
                                    <Table size="small" aria-label="caption table">
                                        <TableHead>
                                            <TableRow sx={{ borderTop: '2px solid black', borderBottom: '2px solid black' }}>
                                                <TableCell sx={{ fontWeight: 'bold' }} align={'left'}>SKU Code</TableCell>
                                                <TableCell sx={{ fontWeight: 'bold' }} align={'left'}>SKU</TableCell>
                                                <TableCell sx={{ fontWeight: 'bold' }} align={'left'}>UOM</TableCell>
                                                <TableCell sx={{ fontWeight: 'bold' }} align={'right'}>WAC Price</TableCell>
                                                {/* <TableCell sx={{ fontWeight: 'bold' }} align={'right'}>Selling Price</TableCell> */}
                                                <TableCell sx={{ fontWeight: 'bold' }} align={'right'}>Inbound Qty</TableCell>
                                                <TableCell sx={{ fontWeight: 'bold' }} align={'right'}>Inbound Amount</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody sx={{ borderBottom: '2px solid black' }}>
                                            {goodDataDetails.map((data, index) => {
                                                if (data.wacAmount > 0) {
                                                    return (
                                                        <TableRow sx={{ minHeight: "5px", height: "5px" }} key={index}>
                                                            <TableCell sx={{ fontWeight: 'bold' }} align={'left'} >
                                                                {data.productCode}
                                                            </TableCell>
                                                            <TableCell sx={{ fontWeight: 'bold' }} align={'left'}>
                                                                {data.productName}
                                                            </TableCell>
                                                            <TableCell sx={{ fontWeight: 'bold' }} align={'left'}>
                                                                {data.measuringUnit == 2 ? 'KG' : 'Unit'}
                                                            </TableCell>
                                                            <TableCell sx={{ fontWeight: 'bold' }} align={'right'} >
                                                                {parseFloat(data.wacAmount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                            </TableCell>
                                                            {/* <TableCell sx={{ fontWeight: 'bold' }} align={'right'} >
                                                                -
                                                            </TableCell> */}
                                                            <TableCell sx={{ fontWeight: 'bold' }} align={'right'} >
                                                                {parseFloat(data.totalAmount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                            </TableCell>
                                                            <TableCell sx={{ fontWeight: 'bold' }} align={'right'} >
                                                                {parseFloat(data.wacAmount * data.totalAmount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                            </TableCell>
                                                        </TableRow>
                                                    )
                                                }
                                            })}
                                        </TableBody>
                                        <TableRow sx={{ borderBottom: '2px solid black', minHeight: "5px", height: "5px" }}>
                                            <TableCell sx={{ fontWeight: 'bold' }} colSpan={4} align={'left'} >
                                                Total
                                            </TableCell>
                                            <TableCell sx={{ fontWeight: 'bold' }} align={'right'} >
                                                {parseFloat(goodDataDetails.reduce((accumulator, current) => accumulator + current.totalAmount, 0)).toLocaleString(undefined, { minimumFractionDigits: 2 })}
                                            </TableCell>
                                            <TableCell sx={{ fontWeight: 'bold' }} align={'right'} >
                                                {parseFloat(goodDataDetails.reduce((accumulator, current) => accumulator + (current.wacAmount * current.totalAmount), 0)).toLocaleString(undefined, { minimumFractionDigits: 2 })}
                                            </TableCell>
                                        </TableRow>
                                    </Table>
                                </TableContainer>
                                <Stack>
                                    <div>&nbsp;</div>
                                    <Box display="flex" justifyContent="flex-start" >
                                        <h5 style={{ marginLeft: '5px', width: '220px' }}>Inbound Quantity KG</h5>
                                        <h5 style={{ width: '220px' }}>
                                            {': ' + parseFloat(goodDataDetails.filter((item) => item.measuringUnit === 2).reduce((accumulator, current) => accumulator + current.totalAmount, 0)).toLocaleString(undefined, { minimumFractionDigits: 2 })}
                                        </h5>
                                        <h5 style={{ marginLeft: '50px', width: '50px' }}></h5>
                                        <h5 style={{ width: '50px' }}></h5>
                                    </Box>
                                    <Box display="flex" justifyContent="flex-start" >
                                        <h5 style={{ marginLeft: '5px', width: '220px' }}>Inbound Quantity UNITS</h5>
                                        <h5 style={{ width: '220px' }}>
                                            {': ' + parseFloat(goodDataDetails.filter((item) => item.measuringUnit === 1).reduce((accumulator, current) => accumulator + current.totalAmount, 0)).toLocaleString(undefined, { minimumFractionDigits: 2 })}
                                        </h5>
                                        <h5 style={{ marginLeft: '50px', width: '50px' }}></h5>
                                        <h5 style={{ width: '50px' }}></h5>
                                    </Box>
                                </Stack>
                                <div>&nbsp;</div>
                            </>
                        </Card>
                    </Box>
                </Stack>
            </Container>
        );
    }
}
